import styles from './style.postcss';
import React from 'react';
import classnames from 'classnames';
import { PageCard } from 'omni-common-ui';
import RadialScoreDisplay from 'components/RadialScoreDisplay';
import ScoreBand from '../ScoreBand';
import ScoreStar from '../ScoreStar';
import PropTypes from 'prop-types';

export const ProgressTestCard = (props) => {
  const { publishedDateStr, name, percentage, isSSCourseTypeGroup, className } = props;
  return <PageCard className={classnames(className, styles.ProgressTestCard)}>
    <PageCard.Heading text="Progress" />
    <PageCard.Content>
      <div className={styles.ProgressTestCard_wrapper}>
        <div className={styles.ProgressTestCard_wrapper_narrative}>
          <h2 className={styles.ProgressTestCard_wrapper_narrative_subTitle}>
            {name}<br />
            Total score:&nbsp;
            <span className={styles.ProgressTestCard_wrapper_scoreText}>
              {percentage}%
            </span>
          </h2>
          <ScoreBand score={percentage} />
          <p>
            <time dateTime={publishedDateStr}>
              {publishedDateStr}
            </time>
          </p>
        </div>
        {isSSCourseTypeGroup ?
          <ScoreStar currentResult={percentage}
              fullMark={100} /> :
          <RadialScoreDisplay className={styles.ProgressTestCard_wrapper_radialScore}
              radius={40}
              circleStrokeWidth={2}
              edgeSize={120}
              forcedTextY={66}
              unit="percent"
              displayText
              formatText={(value) => `${value}%`}
              circleStroke="transparent"
              progressStroke="#74d17f"
              value={percentage} />}
      </div>
    </PageCard.Content>
  </PageCard>;
};

ProgressTestCard.propTypes = {
  className: PropTypes.object,
  publishedDateStr: PropTypes.string,
  name: PropTypes.string,
  percentage: PropTypes.number,
  isSSCourseTypeGroup: PropTypes.bool.isRequired,
};

export default ProgressTestCard;



// WEBPACK FOOTER //
// ./containers/Group/ProgressReport/StudentReportView/ProgressTestCard/index.jsx